import { HTMLAttributeAnchorTarget } from 'react';
import FontBody1 from '../../fonts/font-body1/font-body1';
import { FONT_VARIANT } from '../../fonts/font-props';
import { IconProps } from '../../icons/icon-props-interface';
import Icon from '../../icons/icon/icon';
import { BUTTON_VARIANTS } from '../button-variants';
import './button-link.scss';

interface Props {
    disabled?: boolean,
    variant?: BUTTON_VARIANTS,
    text?: string,
    target?: HTMLAttributeAnchorTarget | undefined,
    href?: string,
    leftIcon?: React.FC<IconProps>,
    rightIcon?: React.FC<IconProps>,
}

export const ButtonLink: React.FC<Props> = ({ 
    disabled = false,
    variant = BUTTON_VARIANTS.Primary,
    text,
    target = '_blank',
    href,
    leftIcon,
    rightIcon,
}) => {
    return (
        <a href={!disabled ? href : '/#'} target={target} className={`button-link ${variant}${ disabled ? ' disabled' : '' }`}>
            {leftIcon && <Icon Component={leftIcon} disabled={disabled} />}
            <FontBody1 variant={[FONT_VARIANT.BOLD, FONT_VARIANT.UPPERCASE]}>{text}</FontBody1>
            {rightIcon && <Icon Component={rightIcon} disabled={disabled} />}
        </a>
    );

}
